import { useState, useEffect } from "react";

const API="https://pokeapi.co/api/v2/pokemon?limit=100000&offset=0"

function Api() {
    const [pokemons ,setPokemons] = useState([])

    useEffect(() => {
        /// llamado a la api
        fetch(API)
            .then(response => response.json())
            .then(data => setPokemons(data.results))
        /// si esta vacio [ ] solo se ejecuta una vez
    }, []);
    return pokemons;
};

export default Api;